module.exports = __webpack_public_path__ + "media/images/pack-04-960a878fcdb047a510d0aab5c238f9ec.webp";